/* eslint-disable handle-callback-err */
/**
 * WebSocket Module
 */
import SockJS from 'sockjs-client'
import Stomp from 'stomp-websocket'
import eventBus from '../../../event_bus'
import callServer from '../call/callServer'

const getDefaultState = () => {
  return {
    stompClient: null,
    isCallApiConnecting: false,
    isCallApiConnected: false,
    callApiConnectionTrigger: 1,
    currentSubscription: null,
    callApiUserId: null
  }
}

const state = getDefaultState()

const getters = {
  IS_CALL_API_CONNECTED: (state) => { return state.isCallApiConnected },
  callApiUserId: (state) => { return state.callApiUserId }
}
const mutations = {
  START_CALL_API_CONNECT (state) {
    state.isCallApiConnecting = true
  },
  END_CALL_API_CONNECT (state) {
    state.isCallApiConnecting = false
    state.isCallApiConnected = true
    state.stompClient.connected = true
    return true
  },
  FAIL_CALL_API_CONNECT (state) {
    state.isCallApiConnecting = false
    state.isCallApiConnected = false
    state.stompClient.connected = false
  },
  callApiSubScribe (state, payload) {
    state.isCallApiConnecting = false
    let subscription = state.currentSubscription = state.stompClient.subscribe(
      payload.subscribeUrl,
      tick => payload.callBack(JSON.parse(tick.body)), {})

    state.subscription = {
      subscriptionUrl: payload.subscribeUrl,
      id: subscription.id,
      subscription: subscription
    }
  },
  forceCallApiCloseSubscription (state) {
    if (state.subscription) {
      state.subscription.subscription.unsubscribe()
    } else {
      console.log('연결되어있는 소켓이 없습니다.')
    }
  },
  changeCallApiUserId (state, userId) {
    state.callApiUserId = userId
  }
}

const actions = {
  async call_api_connect ({commit, state}, payload) {
    if (state.isCallApiConnected || (state.isCallApiConnecting && !state.isCallApiConnected) || (payload !== 'KT' && !callServer.state.callApiUrl)) {
      return false
    }

    const callSocketUrl = payload === 'KT' ? `${process.env.BASE_URL}/api/webSocket` : `${callServer.state.callApiUrl}/api/call/webSocket`
    commit('START_CALL_API_CONNECT')
    state.stompClient = Stomp.over(new SockJS(callSocketUrl))
    if (process.env.NODE_ENV === 'production') {
      state.stompClient.debug = null
    }
    state.stompClient.connect(
      {},
      frame => {
        commit('END_CALL_API_CONNECT')
        eventBus.$emit('call-api-socket-connection-success')
        return true
      },
      error => {
        commit('forceCallApiCloseSubscription')
        commit('FAIL_CALL_API_CONNECT')
        eventBus.$emit('call-api-reconnect-start')
      })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/callApiWebsocket/index.js